import React, { FC, ReactElement, MouseEvent } from 'react';
import classnames from 'classnames';

import styles from './MenuItem.module.css';

interface MenuItemProps {
    className?: string;
    text: string;
    icon?: ReactElement;
    pressed?: boolean;
    disabled?: boolean;
    testId?: string;
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

export const MenuItem: FC<MenuItemProps> = ({
    text,
    icon,
    className,
    onClick,
    disabled,
    pressed,
    testId,
}) => (
    <button
        type="button"
        className={classnames(styles.root, className)}
        onClick={onClick}
        aria-pressed={pressed}
        disabled={disabled}
        data-testid={testId}
    >
        <span className={styles.text}>{text}</span>
        {icon && (
            <span className={styles.icon} aria-hidden="true">
                {icon}
            </span>
        )}
    </button>
);
